import React, { Component } from 'react';
import includes from 'lodash/includes';

type Props = {
  url: string;
  aspectRatio: number | any;
  heightAdjust: number | any;
  onMount?: () => void;
  handleOnLoad?: () => void;
};

type State = {
  width: number;
  height: number;
};

export default class ApplicationIFrame extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
      height: window.innerHeight
    };
  }

  updateDimensions: any = (aspectRatio, heightAdjust) => {
    const height = window.innerHeight - heightAdjust;
    const width =
      aspectRatio && !isNaN(aspectRatio) ? height * aspectRatio : window.innerWidth - heightAdjust;

    this.setState({
      width,
      height
    });
  };

  componentDidMount() {
    const { aspectRatio, heightAdjust }: any = this.props;
    let ratioNum;

    if (includes(aspectRatio, '/')) {
      const bits = aspectRatio.split('/');

      ratioNum = bits[0] / bits[1];
    } else {
      ratioNum = parseInt(aspectRatio, 10);
    }
    if (this.props.onMount) {
      this.props.onMount();
    }
    this.updateDimensions(ratioNum, heightAdjust);
    window.addEventListener('resize', this.updateDimensions(ratioNum, heightAdjust));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  render() {
    const { url } = this.props;

    return (
      <iframe
        title="LWT App Viewer"
        // TODO need to fix this for Workbook that doesn't pass aspectRatio or heightAdjust
        style={{
          width: this.state.width || '60vw',
          height: this.state.height || '60vh',
          display: 'block',
          border: 0
        }}
        src={url}
        onLoad={this.props.handleOnLoad}
      />
    );
  }
}
